
import breakpointMixin from '~/mixins/breakpoints'
import cssToObjectMixin from '~/mixins/cssToObject'

export default {
  mixins: [breakpointMixin, cssToObjectMixin],
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      html: null,
    }
  },
  computed: {
    containerStyles() {
      const styles = {}

      styles.position = this.blok.position
      styles.maxWidth = this.getBreakpointValue(this.blok.maxWidth)
      styles.top = this.getBreakpointValue(this.blok.top)
      styles.bottom = this.getBreakpointValue(this.blok.bottom)
      styles.left = this.getBreakpointValue(this.blok.left)
      styles.right = this.getBreakpointValue(this.blok.right)
      styles.margin = this.getBreakpointValue(this.blok.margin)
      styles.width = this.getBreakpointValue(this.blok.width)
      styles.height = this.getBreakpointValue(this.blok.height)

      return { ...styles, ...this.parseCSSToObject(this.blok?.styles) }
    },
  },
  mounted() {
    this.$nextTick(async () => {
      if (this.blok.src?.filename && this.blok.src?.filename.includes('svg')) {
        const raw = await this.fetchAsset(this.blok.src?.filename)
        this.html = raw
      }
    })
  },
  methods: {
    async fetchAsset(url) {
      return await this.$axios
        .get(this.buildUrl(url))
        .then((res) => res.data)
        .catch((err) => console.warn(err))
    },
    buildUrl(url = '') {
      if (!url) return
      const protocol = 'https://'
      const [, domain] = url.split('https://')

      return protocol + 's3.amazonaws.com/' + domain
    },
  },
}
